module.exports = __webpack_public_path__ + "static/img/19.7be61bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background/19.jpg
// module id = T+tt
// module chunks = 0